export { default } from './stockadjustmentinsert';
